export enum MapMarkerStyle {
  camera = 'camera',
  business = 'business',
  group = 'group'
}